// Open a PDF Blob (as returned by an RTK Query blob endpoint) in a new tab,
// falling back to a download if the browser blocks the popup.
export const openPdfBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const win = window.open(url, '_blank');
  if (!win) {
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
  // Give the new tab time to load before releasing the object URL.
  setTimeout(() => window.URL.revokeObjectURL(url), 60000);
};

// Send a PDF Blob straight to the browser's print dialog, skipping the
// download-then-open-then-print detour. The blob is loaded into an off-screen
// iframe so the viewer's own print command can be triggered on it.
export const printPdfBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const iframe = document.createElement('iframe');
  // Deliberately not display:none — an iframe without layout has nothing to
  // print, and browsers silently do nothing.
  iframe.style.position = 'fixed';
  iframe.style.right = '0';
  iframe.style.bottom = '0';
  iframe.style.width = '0';
  iframe.style.height = '0';
  iframe.style.border = '0';
  iframe.src = url;

  iframe.onload = () => {
    try {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      // print() blocks until the dialog closes, but the spooler still needs the
      // document afterwards — hold on to both for a while.
      setTimeout(() => {
        iframe.remove();
        window.URL.revokeObjectURL(url);
      }, 60000);
    } catch (err) {
      // Some browsers refuse to print an embedded PDF viewer. Fall back to
      // opening it, where the user can print from the viewer itself.
      iframe.remove();
      window.URL.revokeObjectURL(url);
      openPdfBlob(blob, filename);
    }
  };

  document.body.appendChild(iframe);
};
